/**
* this file contains all table column definitions for the transaction table
*
* Created by Tom on 24/06/18
*/
import moment from 'moment'

import { intlNumberFormatter } from '../../utility/utilities'

const tableColumns = [
    {
        id: "Date",
        Header: "Date",
        accessor: d => moment(d.Date).local().format("DD MMM YY"),
        headerClassName: "tTable__header",
        width: 80,
        style: {
            textAlign: 'center'
        }
    },
    {
        id: "Description",
        Header: "Statement",
        accessor: "Description",
        headerClassName: "tTable__header",
        width: 150,
        style: {
            textAlign: 'center'
        }
    },
    {
        id: "DepositAmount",
        Header: "Deposit Amount",
        accessor: a => intlNumberFormatter('en-AU', 'currency', 'AUD', parseFloat(a.DepositAmount)),
        headerClassName: "tTable__header",
        width: 120,
        style: {
            textAlign: 'center'
        }
    },
    {
        id: "Direction",
        Header: "Direction",
        accessor: "Direction",
        headerClassName: "tTable__header",
        width: 120,
        style: {
            textAlign: 'center'
        }
    },
    {
        id: "RunningTotal",
        Header: "Running Total",
        accessor: d => intlNumberFormatter('en-AU', 'currency', 'AUD', parseFloat(d.RunningTotal)),
        headerClassName: "tTable__header",
        width: 120,
        style: {
            textAlign: 'center'
        }
    },
    {
        id: "WithdrawalAmount",
        Header: "Withdrawal",
        accessor: d => intlNumberFormatter('en-AU', 'currency', 'AUD', parseFloat(d.WithdrawalAmount)),
        headerClassName: "tTable__header",
        width: 120,
        style: {
            textAlign: 'center'
        }
    }
]

export default tableColumns



// WEBPACK FOOTER //
// ./src/components/Transaction/tableColumns.js